export default __webpack_public_path__ + "static/card-red-7640e7cb109d861cfcd38f43551a2319.png";